<template>
  <div class="mask" v-show="visible" @click="close" v-prevent-overscroll :style="{'background-color': bgc }">
    <slot />
  </div>
</template>

<script>
// import {ModalHelper} from '@/utils/utils'
export default {
  name: "Cmask",
  props: {
    opacity: {
      type: Number,
      default: 0.5
    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    showMask: {
      handler(n, o) {
        if (n) {
          // ModalHelper.afterOpen();
          // document.documentElement.style.position = "fixed";
          // document.body.style.overflow = "hidden"; //隐藏滚动条
        } else {
          // ModalHelper.beforeClose();
          // document.documentElement.style.position = "static";
          // document.body.style.overflow = ""; //出现滚动条
        }
        this.visible = n;
      },
      immediate: true
    }
  },
  computed: {
    bgc() {
      return `rgba(0,0,0,${this.opacity > 0.8 ? 0.8 : this.opacity})`;
    }
  },
  created() {},
  mounted() {},
  data() {
    return {
      visible: true,
      scrollTop: 0
    };
  },
  methods: {
    close() {
      this.$emit("close", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
</style>
